import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MailService {
  private url = environment.webUrl;

  constructor(private httpClient: HttpClient) {}

  sendContactUs(fullName, phone, email, reason) {
    const mailObj = { fullName, phone, email, reason };
    return this.httpClient.post(
      this.url + '/mail.php?type=request-call',
      JSON.stringify(mailObj)
    );
  }

  sendRejection(order) {
    // const {
    //   createdAt,
    //   deliveryFee,
    //   email,
    //   invoice,
    //   name,
    //   paymentMethod,
    //   phone,
    //   requestAcceptedBy,
    //   requestBy,
    //   requestRejectedBy,
    //   requestType,
    //   status,
    //   details
    // } = order;;

    const mailObj = order;
    return this.httpClient.post(
      this.url + '/mail.php?type=rejection',
      JSON.stringify(mailObj)
    );
  }

  sendAcceptance(order) {
    // const {
    //   createdAt,
    //   deliveryFee,
    //   email,
    //   invoice,
    //   name,
    //   paymentMethod,
    //   phone,
    //   requestAcceptedBy,
    //   requestBy,
    //   requestRejectedBy,
    //   requestType,
    //   status,
    //   details
    // } = order;

    const mailObj = order;
    return this.httpClient.post(
      this.url + '/mail.php?type=acceptance',
      JSON.stringify(mailObj)
    );
  }

  sendCompletion(order) {
    // const {
    //   createdAt,
    //   deliveryFee,
    //   email,
    //   invoice,
    //   name,
    //   paymentMethod,
    //   phone,
    //   requestAcceptedBy,
    //   requestBy,
    //   requestRejectedBy,
    //   requestType,
    //   status,
    //   details
    // } = order;

    const mailObj = order;
    return this.httpClient.post(
      this.url + '/mail.php?type=order-complete',
      JSON.stringify(mailObj)
    );
  }
}
